<template>
  <div class="user">
    <div style="font-size: 24px; font-weight: bold;">用户管理</div>
    <a-divider></a-divider>
    <div style="font-size: 18px; padding-left: 8px; font-weight: bold;">用户列表</div>
    <a-table
      :style="`font-size: ${isMobile() ? '10px': '14px'};`"
      :columns="columns"
      size="middle"
      :data-source="users"
      :pagination="{ pageSize: 20 }"
      :scroll="{ x: 400 }"
    />
    <a-divider></a-divider>
    <div style="font-size: 18px; padding-left: 8px; font-weight: bold;">用户注册</div>
    <div style="margin: 20px 8px;">
      <a-button type="primary" @click="generateRegistCode">生成注册码</a-button>
    </div>
    <div v-for="code of registCode" :key="code">
      <pre>{{ code }}</pre>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        fixed: 'left',
        width: 48
      }, {
        title: '用户名',
        dataIndex: 'username',
        fixed: 'left',
        width: 72
      }, {
        title: '昵称',
        dataIndex: 'nickname',
        width: 100
      }, {
        title: '邮箱',
        dataIndex: 'email',
        width: 150
      }, {
        title: '密码',
        dataIndex: 'password',
        width: 300
      }
    ];
    const users = [];
    return {
      columns,
      loading: true,
      registCode: [],
      users
    };
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    async generateRegistCode () {
      try {
        const r = await this.$api().admin.generateRegistCode();
        this.registCode = r.data;
      } catch (e) {
        this.$message().error(e.message);
      }
    }
  },
  async mounted () {
    try {
      const r = await this.$api().admin.getUsers();
      this.users = r.data;
      this.loading = false;
    } catch (e) {
      this.$message().error(e.message);
    }
  }
};
</script>
<style scoped>
.user {
  height: 100%;
  width: 100%;
}
</style>
